import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Grow from "@mui/material/Grow";
import Collapse from "@mui/material/Collapse";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { TEXT, MAX_DISPLAYED_ERRORS } from "../constants";
import { SystemProps } from "@mui/system";

interface ErrorContentProps {
  errors: string[];
}

const errorContainerStyles: SystemProps = {
  fontSize: "large",
  color: "error.main",
  width: 500,
  padding: 1.5,
  borderRadius: 1,
  border: "1px solid",
  borderColor: "error.light",
  bgcolor: "error.lightest",
};

const errorListStyles: SystemProps = {
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 1,
  paddingLeft: 2,
  margin: 0,
  color: "error.dark",
};

export const ErrorContent: React.FC<ErrorContentProps> = ({ errors }) => {
  return (
    <Box>
      <Grow in={true} timeout={500}>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          <ErrorOutlineIcon color="error" sx={{ fontSize: 64 }} />
          <Typography
            variant="h4"
            align="center"
            color="error"
            fontWeight="medium"
          >
            {TEXT.ERROR_CSV_VALIDATION}
          </Typography>

          <Collapse in={true} timeout={700}>
            <Box {...errorContainerStyles}>
              <Stack {...errorListStyles} component="ul">
                {errors.slice(0, MAX_DISPLAYED_ERRORS).map((error, index) => (
                  <Box component="li" key={index} paddingLeft={0.5}>
                    <Typography variant="body2" color="error.dark">
                      {error}
                    </Typography>
                  </Box>
                ))}

                {errors.length > MAX_DISPLAYED_ERRORS && (
                  <Box component="li" paddingLeft={0.5}>
                    <Typography
                      variant="body2"
                      color="error.dark"
                      fontStyle="italic"
                    >
                      {TEXT.ERROR_MORE_ITEMS(
                        errors.length - MAX_DISPLAYED_ERRORS
                      )}
                    </Typography>
                  </Box>
                )}
              </Stack>
            </Box>
          </Collapse>
        </Stack>
      </Grow>
    </Box>
  );
};
